import Drawer from '@mui/material/Drawer'
import Menu from '@mui/material/Menu'
import Slider from '@mui/material/Slider'
import React from 'react'

export const SingleSlider = ({
  className,
  ...rest
}: React.ComponentProps<typeof Slider>) => (
  <Slider
    className={`text-[#D1E9F4] h-[5px] [&_.MuiSlider-track]:border-0 [&_.MuiSlider-track]:text-[#00A4FF] [&_.MuiSlider-rail]:opacity-100 [&_.MuiSlider-thumb]:h-[16px] [&_.MuiSlider-thumb]:w-[16px] [&_.MuiSlider-thumb]:bg-[#00A4FF] [&_.MuiSlider-thumb]:border-[2px] [&_.MuiSlider-thumb]:border-solid [&_.MuiSlider-thumb]:border-[#FFFFFF] [&_.MuiSlider-thumb]:shadow-[0_1px_4px_rgba(0,0,0,0.2)] [&_.MuiSlider-thumb:before]:hidden [&_.MuiSlider-thumb:hover]:shadow-[0_0_0_6px_rgba(0,164,255,0.125)] [&_.MuiSlider-thumb.Mui-focusVisible]:shadow-[0_0_0_6px_rgba(0,164,255,0.125)] ${className ?? ''}`.trim()}
    {...rest}
  />
)

export const StyledDrawer = ({
  className,
  anchor,
  slotProps,
  ...rest
}: React.ComponentProps<typeof Drawer>) => {
  const paperRounding =
    anchor === 'top'
      ? 'rounded-[0_0_24px_24px]'
      : anchor === 'bottom'
        ? 'rounded-[24px_24px_0_0]'
        : ''
  const paperSizing =
    anchor === 'top' || anchor === 'bottom'
      ? 'h-[calc(100vh-90px)] max-h-[calc(100vh-90px)] overflow-hidden!'
      : ''
  return (
    <Drawer
      anchor={anchor}
      className={className ?? ''}
      slotProps={{
        ...slotProps,
        paper: {
          ...slotProps?.paper,
          className: `${paperRounding} ${paperSizing} ${
            (slotProps?.paper as { className?: string } | undefined)
              ?.className ?? ''
          }`.trim()
        }
      }}
      {...rest}
    />
  )
}

export const StyledMenu = ({
  className,
  ...rest
}: React.ComponentProps<typeof Menu>) => (
  <Menu
    className={`[&_.MuiPaper-root]:rounded-[16px] [&_.MuiPaper-root]:shadow-[0_8px_30px_rgba(0,0,0,0.12)] [&_.MuiPaper-root]:border [&_.MuiPaper-root]:border-solid [&_.MuiPaper-root]:border-[#D1E9F4] ${className ?? ''}`.trim()}
    {...rest}
  />
)
